var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9034 8.328C13.8082 8.47733 11.5304 12 8.00014 12C4.45186 12 2.1906 8.47533 2.0961 8.326C1.9686 8.124 1.96785 7.878 2.0946 7.676C2.18835 7.526 4.43386 4 8.00014 4C11.5484 4 13.8097 7.52467 13.9042 7.67467C14.0324 7.87733 14.0317 8.12533 13.9034 8.328ZM12.3637 8C11.7772 7.22333 10.1294 5.33333 8.00014 5.33333C5.85962 5.33333 4.21861 7.22333 3.63586 7.99933C4.22161 8.77467 5.86937 10.6667 8.00014 10.6667C10.1279 10.6667 11.7757 8.77733 12.3637 8ZM8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.b4d8ff927c50e945942e28fd7937139d.svg";
export { ForwardRef as ReactComponent };